<template>
  <!-- Main -->
  <div id="main">
    <!-- 優惠 -->
    <div id="mainDiscount">
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">優惠</span>
              <a class="add" @click="openAddDialog()">
                <FontAwesomeIcon icon="plus" />
              </a>
            </div>
            <!-- <data-tables
              :data="promotions"
              :pagination-props="{ pageSizes: [10, 20, 50] }"
              :filters="filters"
              :table-props="tableProps"
              :header-cell-style="content"
            >
              <el-table-column
                label="狀態"
                prop="enabled"
                sortable="custom"
                min-width="30px"
              >
                <template slot-scope="scope">
                  <label class="switch">
                    <input type="checkbox" v-model="scope.row.enabled" 
                       @change="toggle(scope.row, scope.row.enabled)"/>
                    <span class="slider round"></span>
                  </label>
                </template>
              </el-table-column>
              <el-table-column
                label="名稱"
                prop="displayName"
                sortable="custom"
                min-width="30px"
              >
                <template slot-scope="scope">
                  <span class="content"> {{ scope.row.displayName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="時間"
                prop="duration"
                sortable="custom"
                min-width="30px"
              >
                <template slot-scope="scope">
                  <span class="content">{{ scope.row.start }}~{{ scope.row.end }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="取餐方式"
                prop="mealType"
                min-width="30px"
              >
                <template slot-scope="scope">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <span class="content" v-if="scope.row.promotionSettings[item.name].checked">
                      {{ item.title }}
                    </span>
                  </div> 
                </template>
              </el-table-column>
              <el-table-column
                label="門檻"
                prop="threshold"
                min-width="30px"
              >
                <template slot-scope="scope">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <span class="content" v-if="scope.row.promotionSettings[item.name].checked">
                      {{ scope.row.promotionSettings[item.name].thresholdMsg }}
                    </span>
                  </div> 
                </template>
              </el-table-column>
              <el-table-column
                label="人數"
                min-width="30px"
              >
                <template slot-scope="scope">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <span class="content" v-if="scope.row.promotionSettings[item.name].checked">
                      <span v-if="scope.row.promotionSettings[item.name].totalUsage" class="content"> {{ scope.row.promotionSettings[item.name].totalUsage }} 人 </span>
                      <span v-else class="content">不限</span>
                    </span>
                  </div> 
                </template>
              </el-table-column>
              <el-table-column
                label="會員"
                prop="roleRestrictions"
                min-width="30px"
              >
                <template slot-scope="scope">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <div v-if="scope.row.roleRestrictions[item.name].checked">
                      <span class="content" 
                        v-if="scope.row.roleRestrictions[item.name].userType === 'new'"
                        >新戶
                        <span class="content" 
                          v-if="scope.row.roleRestrictions[item.name].limitPerUser"
                        >
                          (限{{
                            scope.row.roleRestrictions[item.name].limitPerUser
                          }}次)
                        </span>
                      </span>
                      <span class="content"
                        v-else-if="scope.row.roleRestrictions[item.name].userType === 'old'">舊戶</span>
                      <span class="content" v-else>不限</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="優惠"
                prop="promotionSettings"
                min-width="30px"
              >
                <template slot-scope="scope">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <span v-if="scope.row.promotionSettings[item.name].checked">
                      {{ scope.row.promotionSettings[item.name].discountMsg }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column label="" min-width="40px">
                <template slot-scope="scope">
                  <div class="action">
                    <a>
                      <FontAwesomeIcon icon="pen" />
                    </a>
                    <a @click.native="remove(scope.row.id)">
                      <FontAwesomeIcon icon="trash" />
                    </a>
                    <n-button type="primary" simple="" @click.native="remove(scope.row.id)">
                        <FontAwesomeIcon icon="trash" />
                      </n-button>
                  </div>
                </template>
              </el-table-column>
            </data-tables> -->
            <!-- <pre>{{ promotions }}</pre> -->
            <table>
              <tr>
                <th></th>
                <th><span class="content">名稱</span></th>
                <th><span class="content">時間</span></th>
                <!-- <th><span class="content">取餐方式</span></th> -->
                <!-- <th><span class="content">門檻</span></th> -->
                <!-- <th><span class="content">人數</span></th> -->
                <!-- <th><span class="content">會員</span></th> -->
                <th><span class="content">優惠方式</span></th>
                <th v-if="userType === 'gaa'"><span class="content" >優惠公告</span></th>
                <th></th>
              </tr>
              <tr
                v-for="(promotion, index) in promotions"
                :key="'promotion-' + index"
              >
                <td align="center">
                  <label class="switch">
                    <input
                      type="checkbox"
                      v-model="promotion.enabled"
                      @change="toggle(promotion, promotion.enabled)"
                    />
                    <span class="slider round"></span>
                  </label>
                </td>
                <td align="center">
                  <span class="content">{{ promotion.displayName }}</span>
                </td>
                <td align="center">
                  <span class="content"
                    >{{ promotion.start }}~{{ promotion.end }}</span
                  >
                </td>
                
                <!-- <td align="center">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <span
                      class="content"
                      v-if="promotion.promotionSettings && promotion.promotionSettings[item.name].checked"
                    >
                      {{ item.title }}
                    </span>
                  </div>
                </td> -->
                <!-- <td align="center">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <span
                      class="content"
                      v-if="promotion.promotionSettings && promotion.promotionSettings[item.name].checked"
                    >
                      {{ promotion.promotionSettings[item.name].thresholdMsg }}
                    </span>
                  </div>
                </td>
                <td align="center">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <span
                      class="content"
                      v-if="promotion.promotionSettings && promotion.promotionSettings[item.name].checked"
                    >
                      <span
                        v-if="promotion.promotionSettings && promotion.promotionSettings[item.name].totalUsage"
                        class="content"
                      >
                        {{ promotion.promotionSettings[item.name].totalUsage }}
                        人
                      </span>
                      <span v-else class="content">不限</span>
                    </span>
                  </div>
                </td> -->
                <!-- <td align="center">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <div v-if="promotion.roleRestrictions && promotion.roleRestrictions[item.name].checked">
                      <span
                        class="content"
                        v-if="
                          promotion.roleRestrictions && promotion.roleRestrictions[item.name].userType ===
                            'new'
                        "
                        >新戶
                        <span
                          v-if="
                            promotion.roleRestrictions && promotion.roleRestrictions[item.name].limitPerUser
                          "
                        >
                          (限{{
                            promotion.roleRestrictions && promotion.roleRestrictions[item.name].limitPerUser
                          }}次)
                        </span>
                      </span>
                      <span
                        class="content"
                        v-else-if="
                          promotion.roleRestrictions && promotion.roleRestrictions[item.name].userType ===
                            'old'
                        "
                        >舊戶</span
                      >
                      <span class="content" v-else>不限</span>
                    </div>
                  </div>
                </td> -->
                <td align="center">
                  <div v-for="(item, index) in types" :key="'type-' + index">
                    <span
                      class="content"
                      v-if="promotion.promotionSettings && promotion.promotionSettings[item.name].checked"
                    >
                      {{ promotion.promotionSettings[item.name].discountMsg }}
                    </span>
                  </div>
                  <!-- 為了顯示舊版優惠格式 -->
                  <div v-if="promotion.description && !promotion.promotionSettings">
                    <span class="content">
                      {{ promotion.description }}
                    </span>
                  </div>
                </td>
                <td align="center" v-if="userType === 'gaa'">
                  <div class="action">
                    <a @click="openAnnouncementDialog(promotion)">
                      <FontAwesomeIcon icon="pen" v-if="promotion.shoppingTips"/>
                      <FontAwesomeIcon icon="plus" v-else/>
                    </a>
                  </div>
                </td>
                <td align="center">
                  <div class="action">
                    <a v-if="false">
                      <FontAwesomeIcon icon="pen" />
                    </a>
                    <a @click="remove(promotion.id)">
                      <FontAwesomeIcon icon="trash" />
                    </a>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
      <!-- 優惠 Popup -->
      <section
        id="popDiscount"
        class="popDiscount popup"
        :class="{
          'display-flex': dialogFormVisible,
          'display-none': !dialogFormVisible
        }"
      >
        <div class="popBody">
          <!-- <pre> {{ editableTabs }} </pre> -->
          <a class="close" @click.prevent="dialogFormVisible = false">
            <FontAwesomeIcon icon="times"
          /></a>
          <section class="popHeader">
            <span class="title">新增優惠</span>
          </section>
          <section class="popMain">
            <div class="flexH width">
              <div class="flexV margin padding width">
                <span class="title">優惠名稱</span>
                <input
                  class="input"
                  type="text"
                  placeholder="名稱(例如：折價10元，最長支援20個字)"
                  v-model="promotionSettings.name"
                />
                <span class="remark center" ><br/></span
                >
              </div>
              <div class="flexV margin padding width">
                <span class="title">優惠時間</span>
                <div class="dateRange" style="width: 100%;">
                  <input type="date" v-model="promotionSettings.start" />
                  <span class="content">-</span>
                  <input type="date" v-model="promotionSettings.end" />
                </div>
                <span class="remark center"
                  >為開始日期的00:00開始，至結束日期的00:00截止</span
                >
              </div>
            </div>
            <div class="type flexH width margin">
              <div class="flexH width">
                <div
                  v-for="item in editableTabs"
                      :key="item.name"
                      :label="item.title"
                      :name="item.name"
                  class="flexH width middle"
                  :class="{'active': item.name === currentTab}"
                  >
                  <label class="check">
                    <input type="checkbox"
                          v-model="item.isChecked"
                          @change="handleTabCheck(item.name)"
                          :disabled="isCreating" />
                    <!-- checked="checked" -->
                    <span class="checkmark checkbox"></span>
                  </label>
                </div>
              </div>
              <div class="flexH width">
                <a v-for="item in editableTabs"
                      :key="item.name"
                      :label="item.title"
                      :name="item.name"
                  class="flexH width middle"
                  :class="{'active': item.name === currentTab}"
                  @click="handleTabClick(item.name)">
                  <span class="content">{{item.title}}</span>
                </a>
                
              </div>
            </div>
          </section>
          <PromotionSettings
            v-for="item in editableTabs"
            :key="item.name"
            :value="item.name"
            v-show="currentTab === item.name"
            :disabled="isCreating"
            :editPromotion="item.editablePromotion"
            @add-cart="onAddCartPromotion"
            @remove-cart="onRemoveCartPromotion"
          >
          </PromotionSettings>
          <section>
            <div class="flexV margin padding width">
              <span class="title">折扣後小數點處理方式</span>
              <div class="dropdown item">
                <select
                  name="type"
                  v-model="promotionSettings.carryMethod"
                  
                >
                  <option value="round">四捨五入</option>
                  <option value="floor">無條件捨去</option>
                  <option value="ceil">無條件進位</option>
                </select>
                <div class="arrow">
                  <FontAwesomeIcon icon="caret-down" />
                </div>
              </div>
            </div>
            
          </section>
          <section class="popFooter">          
            <a class="button cancel white"  @click="dialogFormVisible = false"><span class="remark">取消</span></a>
            <a class="button submit"  @click="addNewPromotion"><span class="remark">新增</span></a>
          </section>
        </div>
      </section>
      <!-- 優惠公告 Popup -->
      <section
        id="popDiscountAnno"
        class="popDiscount popup popDiscountAnno"
        :class="{
          'display-flex': dialogFormVisibleAnno,
          'display-none': !dialogFormVisibleAnno
        }"
      >
        <div class="popBody">
          <a class="close" @click.prevent="closeAnnouncementDialog">
            <FontAwesomeIcon icon="times"
          /></a>
          <section class="popHeader">
            <span class="title">編輯優惠公告
              <a class="trashAnno" @click="showRemoveAnnoAlert(nowAnnoPromotion)"> <FontAwesomeIcon icon="trash" v-if="nowAnnoPromotion&&nowAnnoPromotion['shoppingTips']"/></a>
            </span>
           
          </section>
          <section class="popMain">
            <div class="flexV margin padding width">
              <quill-editor
                class="notranslate"
                v-model="contentAnno"
                ref="myTextEditor"
                :options="editorOption"

              ></quill-editor>
            </div>
          </section>
          <section class="popFooter">          
            <a class="button cancel white"  @click="closeAnnouncementDialog"><span class="remark">取消</span></a>
            <a class="button submit"  @click="editAnnouncement"><span class="remark">送出</span></a>
          </section>
        </div>
      </section>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  fetchPromotions,
} from "src/javascripts/generalPages/fetchData";
import {
  fetchShopInfoByAccountId
} from "src/javascripts/generalPages/fetchForConsoleLog";
import swal from "sweetalert2";
import moment from "moment-timezone";
import {
  createPromotion,
  promotionSetting
} from "src/javascripts/generalPages/postData";
import { deletePromotion } from "src/javascripts/generalPages/deleteData";
import { updatePromotionAnno } from "src/javascripts/gaa/updateData"
import PromotionSettings from "./PromotionSettings";
import { quillEditor } from "vue-quill-editor";
export default {
  components: {
    FontAwesomeIcon,
    PromotionSettings,
    quillEditor
  },
  data() {
    return {
      isCreating: false,
      businessId: null,
      types: [
        {
          title: "全部",
          name: "all"
        },
        {
          title: "內用",
          name: "eatIn"
        },
        {
          title: "自取",
          name: "toGo"
        },
        {
          title: "外送",
          name: "delivery"
        }
      ],
      initialized: false,
      promotions: [],
      tableData: [],
      // filters: [
      //   {
      //     prop: ["displayName", "description", "duration"],
      //     value: ""
      //   }
      // ],
      // tableProps: {
      //   defaultSort: {
      //     prop: "displayName",
      //     order: "descending"
      //   }
      // },
      dialogFormVisible: false,
      dialogFormVisibleAnno: false,
      nowAnnoPromotion: null,
      contentAnno: null,
      editorOption: {
        // some quill options
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],    //加粗，斜體，下劃線，刪除線
            // ['blockquote', 'code-block'],     //引用，程式碼塊
            // [{ 'header': 1 }, { 'header': 2 }],        // 標題，鍵值對的形式；1、2表示字型大小
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
            // [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下標
            // [{ 'indent': '-1'}, { 'indent': '+1' }],     // 縮排
            // [{ 'direction': 'rtl' }],             // 文字方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字型大小
            [{ 'color': [] }, { 'background': [] }],     // 字型顏色，字型背景顏色
            // [{ 'font': [] }],     //字型
            // [{ 'align': [] }],    //對齊方式
            ['clean'],    //清除字型樣式
          ]
        },
        placeholder: '請輸入公告...',
        theme: 'snow'
      },
      defaultPromotion: {
        // name: null,
        // supportMealTypes: null,
        general: {
          totalUsageType: "none",
          totalUsage: 0,
          discountType: "fixed", // "percentage", "discountPerItems5", "discountPerItemsAvg", "discountPerItemsLow"
          fixed: 10,
          percentage: null,
          carryMethod: "floor", // 這邊不用了，改放到promotionSettings
          discountPerItems5: null,
          discountPerItemsAvg: null,
          discountPerItemsLow: null,
          // cartType: "none",
        },
        usageRestrctions: {
          restrictionType: "none", // amount, qty, perItems
          amount: null,
          qty: null,
          perItems: null,
          carts: [{
            discountType: 'fixed',
            amount: 10,
            carts: ''
          }]
        },
        roleRestrictions: {
          userType: "none"
        },
        usageLimits: {
          type: "none",
          limitPerUser: null // 暫時不支援
        },
      },
      promotionSettings: {
        carryMethod: "floor", // 改成放外面
        name: null,
        start: null,
        end: null
      },
      currentTab: "all",
      editableTabs: [],
      defaultCartPromotion: {
        discountType: 'fixed',
        amount: 10,
        carts: ''
      }
    };
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    type() {
      return this.$route.params.type || 'gaa';
    },
    userType: function() {
      return this.$store.getters.userType;
    }
  },
  created: function() {
    // fetch value
    console.log("created!!", this.accountId, this.value);
    fetchShopInfoByAccountId(this.accountId, this.$route.params.type)
      .then(fetchShopInfoRes => {
        console.log("fetchShopInfoRes: ", fetchShopInfoRes);
        this.businessId = fetchShopInfoRes.data.businessId;
        this.getPromotions();
      })
      .catch(fetchShopInfoErr => {
        this.$message({
          type: "error",
          message: `商店：${this.accountId} ，無法取得資料！`
        });
      });
  },
  mounted() {},
  methods: {
    handleTabClick(tabName) {
      if (this.isCreating) return;
      console.log("on tab click: " + tabName);
      this.currentTab = tabName;
    },
    handleTabCheck(tab) {
      console.log("select tab:" + tab);
      var isChecked = this.editableTabs.filter(function(obj) {
        return obj.name == tab;
      })[0].isChecked;

      if (tab == "all" && isChecked === true) {
        this.editableTabs.forEach(obj => {
          if (obj.name != "all") {
            obj.isChecked = false;
          }
        });
      }

      if (tab !== "all" && isChecked === true) {
        this.editableTabs.forEach(obj => {
          if (obj.name == "all") {
            obj.isChecked = false;
          }
        });
      }
      this.currentTab = tab;
    },
    getPromotions() {
      // test Data
      // let temp = [
      //   {
      //     id: 1,
      //     enabled: false,
      //     start: "2022-01-11",
      //     end: "2030-01-01",
      //     settings: {
      //       all: {
      //         checked: true,
      //         general: {
      //           totalUsage: 100,
      //           discountType: "percentage",
      //           percentage: 10,
      //           carryMethod: "round"
      //         },
      //         usageRestrctions: {
      //           restrictionType: "amount",
      //           value: 100
      //         },
      //         roleRestrictions: {
      //           userType: "new"
      //         },
      //         usageLimits: {
      //           limitPerUser: null
      //         }
      //       },
      //       eatIn: {
      //         checked: true,
      //         general: {
      //           totalUsage: null,
      //           discountType: "fixed",
      //           amount: 1
      //         },
      //         usageRestrctions: {
      //           restrictionType: null,
      //           value: null
      //         },
      //         roleRestrictions: {
      //           userType: null
      //         },
      //         usageLimits: {
      //           limitPerUser: null
      //         }
      //       },
      //       toGo: {
      //         checked: false,
      //         general: {
      //           totalUsage: null,
      //           discountType: null
      //         },
      //         usageRestrctions: {
      //           restrictionType: null,
      //           value: null
      //         },
      //         roleRestrictions: {
      //           userType: null
      //         },
      //         usageLimits: {
      //           limitPerUser: null
      //         }
      //       },
      //       delivery: {
      //         checked: false,
      //         general: {
      //           totalUsage: 1,
      //           discountType: "fixed",
      //           amount: 1
      //         },
      //         usageRestrctions: {
      //           restrictionType: "amount",
      //           value: 1
      //         },
      //         roleRestrictions: {
      //           userType: "new"
      //         },
      //         usageLimits: {
      //           limitPerUser: null
      //         }
      //       }
      //     }
      //   },
      //   {
      //     id: 2,
      //     enabled: false,
      //     start: "2020-09-11",
      //     end: "2030-01-01",
      //     settings: {
      //       all: {
      //         checked: true,
      //         general: {
      //           totalUsage: 100,
      //           discountType: "fixed",
      //           amount: 10
      //         },
      //         usageRestrctions: {
      //           restrictionType: "amount",
      //           value: 100
      //         },
      //         roleRestrictions: {
      //           userType: "new"
      //         },
      //         usageLimits: {
      //           limitPerUser: null
      //         }
      //       },
      //       eatIn: {
      //         checked: true,
      //         general: {
      //           totalUsage: null,
      //           discountType: "fixed",
      //           amount: 1
      //         },
      //         usageRestrctions: {
      //           restrictionType: null,
      //           value: null
      //         },
      //         roleRestrictions: {
      //           userType: null
      //         },
      //         usageLimits: {
      //           limitPerUser: null
      //         }
      //       },
      //       toGo: {
      //         checked: false,
      //         general: {
      //           totalUsage: null,
      //           discountType: null
      //         },
      //         usageRestrctions: {
      //           restrictionType: null,
      //           value: null
      //         },
      //         roleRestrictions: {
      //           userType: null
      //         },
      //         usageLimits: {
      //           limitPerUser: null
      //         }
      //       },
      //       delivery: {
      //         checked: false,
      //         general: {
      //           totalUsage: 1,
      //           discountType: "fixed",
      //           amount: 1
      //         },
      //         usageRestrctions: {
      //           restrictionType: "amount",
      //           value: 1
      //         },
      //         roleRestrictions: {
      //           userType: "new"
      //         },
      //         usageLimits: {
      //           limitPerUser: null
      //         }
      //       }
      //     }
      //   }
      // ];
      fetchPromotions({ businessId: this.businessId }, this.type)
        .then(fetchPromotionsRes => {
          console.log("fetchPromotionsRes", fetchPromotionsRes);
          // this.setData(temp);
          if (fetchPromotionsRes.data.length > 0) {
            this.setData(fetchPromotionsRes.data);
          } else {
            this.setData([]);
          }
        })
        .catch(err => {
          console.log("err: ", err);
          this.$message({
            type: "error",
            message: `商店：${this.accountId} ，無法取得資料！`
          });
        });
    },
    setData(data) {
      console.log("Set Promotion Data", data);
      this.promotions = data.map((d, index) => {
        let roleRestrictions = d.settings ? this.parseRoleRestrictions(d.settings) : null;
        let promotionSettings = d.settings ? this.parsePromotionSettings(d.settings): null;
        if (!d.settings) {
          console.log('old promotion format....');
        }
        let start = d.start || d.content.start;
        let end = d.end || d.content.end;
        return Object.assign(
          {},
          {
            index: index,
            id: d.id,
            displayName: d.displayName || '一般折扣',
            // displayName: d.displayName,
            description: d.description,
            class: d.class,
            content: d.content,
            settings: d.settings,
            promotionSettings: promotionSettings,
            roleRestrictions: roleRestrictions,
            start: moment(start)
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD"),
            end: moment(end)
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD"),
            duration: `${moment(start)
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD")}~${moment(end)
              .tz("Asia/Taipei")
              .format("YYYY-MM-DD")}`,
            enabled: d.enabled,
            shoppingTips:d.shoppingTips
          }
        );
      });

      console.log("Promotions: ", this.promotions);
    },
    parsePromotionSettings(data) {
      console.log("parsePromotionSettings");
      var promotionSettings = {};
      Object.keys(data).forEach(function(key) {
        console.log(key);
        //TBD parse promotion settings to string
        let promotion = data[key];
        let description = "";
        let thresholdMsg = "";
        let discountMsg = "";
        switch (promotion["usageRestrctions"]["restrictionType"]) {
          case "amount":
            thresholdMsg =
              "金額滿" + promotion["usageRestrctions"]["value"] + "元";
            break;
          case "qty":
            thresholdMsg =
              "數量滿" + promotion["usageRestrctions"]["value"] + "個";
            break;
          case "perItems":
            thresholdMsg =
              "數量每滿" + promotion["usageRestrctions"]["value"] + "個";
            break;
          case "carts":
            // thresholdMsg =
            //   "加購促銷，同價位第二件";
            let carts = promotion["usageRestrctions"]["value"];
              carts.forEach((item, index) => {
                let discountCarts = item.carts.trim();
                if (index) {
                  thresholdMsg =`加購促銷（題組代碼： ${item.discountCarts}），同價位第二件折${item.amount} 元；`;
                }else {
                  thresholdMsg =`加購促銷（題組代碼： ${item.discountCarts}），同價位第二件折${item.amount} 元；`;
                }
              })
            break;
          default:
            thresholdMsg = "不限消費";
            break;
        }
        description = thresholdMsg;

        switch (promotion["general"]["discountType"]) {
          case "fixed":
            // description += "折" + promotion["general"]["amount"] + "元";
            discountMsg = "折" + promotion["general"]["amount"] + "元";
            break;
          case "percentage":
            discountMsg = "折" + promotion["general"]["percentage"] + "%";
            // TODO: 因為搬出特定設定，先不用顯示到這麼細
            // if (promotion["general"]["carryMethod"] === 'round') {
            //   discountMsg += "（四捨五入）"
            // } else if (promotion["general"]["carryMethod"] === 'ceil') {
            //   discountMsg += "（無條件進位）"
            // } else if (promotion["general"]["carryMethod"] === 'floor') {
            //   discountMsg += "（無條件捨去）"
            // }
            break;
          case "discountPerItems5":
            discountMsg =
              "折價" +
              promotion["general"]["discountPerItems5"] +
              "個 （商品均價後,折5的倍數低價）";
            break;
          case "discountPerItemsAvg":
            discountMsg =
              "折價" + promotion["general"]["discountPerItemsAvg"] + "個 （折商品均價）";
            break;
          case "discountPerItemsLow":
            discountMsg =
              "折價" + promotion["general"]["discountPerItemsLow"] + "個 （折商品最低價）";
            break;
          default:
            discountMsg = "";
            break;
        }
        if (promotion["usageRestrctions"]["restrictionType"] === 'carts') {
          discountMsg = thresholdMsg;
        } 
        if (promotion["usageRestrctions"]["restrictionType"] !== 'carts') {
          description += discountMsg;
        }
        if (promotion["general"]["totalUsage"] > 0) {
          description += "（ 限" + promotion["general"]["totalUsage"] + "人 ）";
        }

        promotionSettings[key] = {
          checked: promotion["checked"],
          description: description,
          thresholdMsg: thresholdMsg,
          discountMsg: discountMsg,
          totalUsage: promotion["general"]["totalUsage"]
        };
      });

      return promotionSettings;
    },
    parseRoleRestrictions(data) {
      console.log("parseRoleRestrictions");
      var roleRestrictions = {};
      Object.keys(data).forEach(function(key) {
        console.log(key, data[key]["roleRestrictions"]);
        roleRestrictions[key] = {
          checked: data[key]["checked"],
          userType: data[key]["roleRestrictions"]["userType"],
          limitPerUser: data[key]["usageLimits"]["limitPerUser"]
        };
      });

      return roleRestrictions;
    },
    remove(id) {
      console.log("remove promotion " + id);
      swal.fire({
        title: `確定要刪除優惠活動嗎？`,
        buttonsStyling: true,
        // confirmButtonClass: "btn btn-success btn-fill",
        showCancelButton: true,
        confirmButtonColor: "#f96332",
        cancelButtonColor: "#cccccc",
        confirmButtonText: "刪除",
        cancelButtonText: "取消"
      }).then(res => {
        console.log("res: ", res);
        if (res.value) {
          let data = {
            id,
            businessId: this.businessId
          };
          deletePromotion(data, this.type)
            .then(deletePromotionRes => {
              let _index = this.promotions.findIndex(d => d.id == id);
              this.promotions.splice(_index, 1);
              this.$message({
                type: "success",
                message: "刪除成功！"
              });
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.message
              });
            });
        }
      });
    },
    toggle(d, enabledValue) {
      let _index = d.index;
      let promotionSettingData = {
        id: d.id,
        class: d.class,
        businessId: this.businessId || 120
      };
      console.log("toggle promotion" + JSON.stringify(promotionSettingData));
      promotionSetting(promotionSettingData, this.type)
        .then(res => {
          this.$message({
            type: "success",
            message: "已更改"
          });
        })
        .catch(err => {
          console.log("err: ", err);
          this.$message({
            type: "error",
            message: err.data.error
          });
          this.promotions[_index].enabled = false;
        });
    },
    closeAnnouncementDialog() {
      this.dialogFormVisibleAnno = false;
      this.nowAnnoPromotion = null;
      this.contentAnno = null
    },
    openAnnouncementDialog(promotion) {
      this.nowAnnoPromotion = promotion
     //this.contentAnno = promotion.shoppingTips
      if(promotion.shoppingTips) {
        try {
          this.$refs.myTextEditor.quill.setContents(JSON.parse(promotion.shoppingTips).ops);
        } catch(err) {
          let d = {
            ops: [{"insert":promotion.shoppingTips}]
          };
          this.$refs.myTextEditor.quill.setContents(d);
          console.log(err);
        }
      }

      this.dialogFormVisibleAnno = true;

    },
    editAnnouncement() {
      console.log("editAnnouncement", this.contentAnno);
      const promotionAnnoData = {
        "promotionId": this.nowAnnoPromotion.id,
        "shoppingTips":  JSON.stringify(this.$refs.myTextEditor.quill.getContents())
       // "updatedAt": "2025-12-30 23:59:59"
      }
      updatePromotionAnno(this.businessId,promotionAnnoData).then(res => {
        this.closeAnnouncementDialog();
        this.nowAnnoPromotion = null;
        this.editPromotionAnno = null;
        this.getPromotions();
        this.$message({
            type: "success",
            message: "已更改"
          });
      }).catch(err => {
          console.log("err: ", err);
          this.$message({
            type: "error",
            message: err.data.error
          });
        });
    },
    showRemoveAnnoAlert(promotion) {
      console.log("remove promotion " + promotion.id);
      swal.fire({
        title: `確定要刪除優惠公告嗎？`,
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonColor: "#f96332",
        cancelButtonColor: "#cccccc",
        confirmButtonText: "刪除",
        cancelButtonText: "取消"
      }).then(res => {
        if (res.value) {
          this.removeAnno()
        }
      });
    },
    removeAnno(){
      console.log("editAnnouncement", this.contentAnno);
      const promotionAnnoData = {
        "promotionId": this.nowAnnoPromotion.id,
        "shoppingTips": null
       // "updatedAt": "2025-12-30 23:59:59"
      }
      updatePromotionAnno(this.businessId,promotionAnnoData).then(res => {
        this.closeAnnouncementDialog();
        this.nowAnnoPromotion = null;
        this.editPromotionAnno = null;
        this.getPromotions();
        this.$message({
            type: "success",
            message: "刪除成功"
          });
      }).catch(err => {
          console.log("err: ", err);
          this.$message({
            type: "error",
            message: err.data.error
          });
        });
    },
    openAddDialog() {
      // this.editPromotion = Object.assign({}, this.defaultPromtion);
      // this.editPromotion.start =  moment().format('YYYY-MM-DD');
      // this.editPromotion.end =  moment().add(7, 'days').format('YYYY-MM-DD')
      this.promotionSettings.start = moment()
        .tz("Asia/Taipei")
        .format("YYYY-MM-DD");
      this.promotionSettings.end = moment()
        .add(7, "days")
        .tz("Asia/Taipei")
        .format("YYYY-MM-DD");
      this.editableTabs.length = 0;
      this.types.forEach(t => {
        this.editableTabs.push({
          title: t.title,
          name: t.name,
          isChecked: false,
          editablePromotion: JSON.parse(JSON.stringify(this.defaultPromotion)) //Object.assign({}, this.defaultPromtion)
        });
      });
      //this.currentTab = 'all'
      this.handleTabClick("all");
      // console.log(this.editableTabs);
      this.dialogFormVisible = true;
    },
    addNewPromotion() {
      function settingToFormula(promotion) {
        let input = promotion.settings;
        let formulas = [];
        let settings = {};

        if (input['all'] && input['all'].checked) { // 全部一樣值
          // 判斷是否要求新戶
          settings['all'] = input.all;
          
        } else { // 每種分別enabled
          for (let m in input) {
            if (input[m].checked) {
              settings[m] = input[m];
            }
          }
        }

        let finalDiscounts = [];;
        // 開始進行轉換
        let requiredModules = {
          'orderVars': false // 首購
        }
        for (let m in settings) {
          // 每種取餐條件要分開看
          
          if (m === 'all') { // 理論上有這個就不會有別種設定
            finalDiscounts.push(`(formulaResults.${m}_roleCheck * formulaResults.${m}_threshold * formulaResults.${m}_rawDiscount)`);
          } else {
            formulas.push({
              "name": `${m}_pickupCheck`,
              "derivation": `{{IF(mealType === '${m}',1,0)}}`,
              "function": "eval"
            })
            finalDiscounts.push(`(formulaResults.${m}_pickupCheck * formulaResults.${m}_roleCheck * formulaResults.${m}_threshold * formulaResults.${m}_rawDiscount)`);
          }
          
          
          // 優惠內容門檻判斷 -------
          let s = settings[m];
          if (s.usageRestrctions) {
            if (s.usageRestrctions.restrictionType === 'amount') { // 消費門檻
              s.threshold = `totalAmount >= ${s.usageRestrctions.value || 0} `
              // {{IF(totalAmount) > ?,totalAmount * 0.05,0)}}
            } else if (s.usageRestrctions.restrictionType === 'qty') {
              s.threshold = `numOfProduct >= ${s.usageRestrctions.value || 0} `;
              formulas.push({ 
                "name": `${m}_discountTimes`,
                "derivation": `1`,
                "function": "eval"
              })
            } else if (s.usageRestrctions.restrictionType === 'perItems') { // 每滿幾個
              formulas.push({
                "name": `${m}_discountTimes`,
                "derivation": `{{FLOOR(numOfProduct / ${s.usageRestrctions.value})}}`,
                "function": "eval"
              });
              s.threshold = `formulaResults.${m}_discountTimes >= 0 `;
              console.log('debug times ' + JSON.stringify(s.usageRestrictions));
            } else if (s.usageRestrctions.restrictionType === 'carts') { // 加購促銷
              let carts = s.usageRestrctions.value;
              let tempDiscountFormulas = ''
              carts.forEach((item, index) => {
                let discountCarts = item.carts.trim().split(',');
                discountCarts = discountCarts.reduce((acc, i) => i ? [...acc, i] : acc, []);
                formulas.push({
                  "name": `${m}_cartDiscount_${index}`,
                  "derivation": `{{MODIFIER_PARITY_FLATOFF(carts, ${ JSON.stringify(discountCarts)}, ${item.amount})}}`,
                  "function": "eval"
                });
                tempDiscountFormulas += tempDiscountFormulas ? ` + formulaResults.${m}_cartDiscount_${index}` : `formulaResults.${m}_cartDiscount_${index}`;
              })
              formulas.push({
                  "name": `${m}_tempDiscount`,
                  "derivation": `{{(${tempDiscountFormulas})}}`,
                  "function": "eval"
                });
              // formulas.push({
              //   "name": `rawValue`,
              //   "derivation": `{{MODIFIER_PARITY_FLATOFF(carts, ${s.usageRestrctions.value}, ${s.general.amount})}}`,
              //   "function": "eval"
              // });
              s.threshold = null;
              console.log('debug times ' + JSON.stringify(s.usageRestrictions));
            }
            
            if (s.threshold) {
              formulas.push({ 
                "name": `${m}_threshold`,
                "derivation": `{{IF(${s.threshold},1,0)}}`,
                "function": "eval"
              })
            } else {
              formulas.push({ 
                "name": `${m}_threshold`,
                "derivation": `1`,
                "function": "eval"
              })
            }
          } else {
            formulas.push({ 
              "name": `${m}_threshold`,
              "derivation": `1`,
              "function": "eval"
            })
          }
          
          if (s.roleRestrictions) {
            
            if (s.roleRestrictions.userType === 'new') { // 限定新戶且從古至今
              requiredModules.orderVars = true;

              formulas.push({ 
                "name": `${m}_roleCheck`,
                "derivation": `{{IF(moduleParams.orderVars.orderTimes < 1, 1, 0)}}`,
                "function": "eval"
              })
            } else {
              formulas.push({ 
              "name": `${m}_roleCheck`,
              "derivation": `1`,
              "function": "eval"
            })
            }
          } else {
            formulas.push({ 
              "name": `${m}_roleCheck`,
              "derivation": `1`,
              "function": "eval"
            })
          }

          // 優惠內容
          if (s.usageRestrctions.restrictionType === 'carts') {
            s.rawDiscount = `formulaResults.${m}_tempDiscount`;  
            // s.rawDiscount = `FLOOR(totalAmount - formulaResults.rawValue)`;                
            // s.rawDiscount = `MODIFIER_PARITY_FLATOFF(carts, ${JSON.stringify(s.usageRestrctions.value)}, ${s.general.amount})`
          }
          if (s.general && s.usageRestrctions.restrictionType !== 'carts') {
            if (s.general.discountType === 'fixed') {
              s.rawDiscount = s.general.amount;
            } else if (s.general.discountType === 'percentage') {
              if (!s.general.amount)
                s.general.amount = 0;

              if (typeof s.general.amount === 'string')
                s.general.amount = parseInt(s.general.amount, 10);

              s.rawDiscount = `totalAmount * ${s.general.amount / 100}`
            } else if (s.general.discountType === 'discountPerItemsAvg') { // 送均價幾個
              // 計算均價
              formulas.push({
                "name": `${m}_numOfItems`,
                "derivation": "{{numOfProduct || 1}}",
                "function": "eval"
              });
              formulas.push({
                "name": `${m}_avgAmount`,
                "derivation": `{{FLOOR(totalAmount / formulaResults.${m}_numOfItems)}}`,
                "function": "eval"
              });
              s.rawDiscount = `formulaResults.${m}_discountTimes * formulaResults.${m}_avgAmount`;
            } else if (s.general.discountType === 'discountPerItems5') {
              // 計算均價
              formulas.push({
                "name": `${m}_avgAmount`,
                "derivation": "{{FLOOR(totalAmount / numOfProduct)}}",
                "function": "eval"
              });
              formulas.push({ 
                "name": `${m}_discountValue`,
                "derivation": `{{FLOOR(formulaResults.${m}_avgAmount / 5) * 5}}`,
                "function": "eval"
              });
              s.rawDiscount = `formulaResults.${m}_discountTimes * formulaResults.${m}_discountValue`;
            }
          } 

          formulas.push({ 
            "name": `${m}_rawDiscount`,
            "derivation": `{{${s.rawDiscount}}}`,
            "function": "eval"
          })

          // TODO: 現在讓每種取餐方式都能設定小數點處理方式，是對的嗎@@...

          // ------ 優惠內容done ------
        }

        let rawDiscountFormula = '';
        for (let i = 0; i < finalDiscounts.length; ++i) {
          if (i > 0)
            rawDiscountFormula += ' + ';

          rawDiscountFormula += finalDiscounts[i];
        }
        formulas.push({
          "name": "rawValue",
          "derivation": `{{${rawDiscountFormula}}}`,
          "function": "eval"
        })
        let carryMethod = promotion.carryMethod ? promotion.carryMethod.toUpperCase() : '';
      
        formulas.push({
          "name": "tmpAmount",
          "derivation": `{{${carryMethod}(totalAmount - formulaResults.rawValue)}}`,
          "function": "eval"
        })
        formulas.push({
          "name": "value",
          // 原本計算公式
          // "derivation": `{{totalAmount - formulaResults.tmpAmount}}`,
          // 根據rawValue 是否為0判斷最後送出的優惠金額，若原本計自出的優惠為0， 直接回0
          "derivation": `{{IF(formulaResults.rawValue === 0, 0, totalAmount - formulaResults.tmpAmount)}}`,  
          "function": "eval"
        })

        // 顯示名稱
        formulas.push({ 
          "name": "displayName",
          "derivation": `{{IF(formulaResults.value > 0,'${promotion.displayName}','')}}`,
          "function": "parse"
        })
        formulas.push({ 
          "name": "text",
          "derivation": `{{IF(formulaResults.value > 0,'${promotion.displayName}','')}}`,
          "function": "parse"
        })
        formulas.push({ 
          "name": "description",
          "derivation": `{{IF(formulaResults.value > 0,'${promotion.displayName}','')}}`,
          "function": "parse"
        })
        formulas.push({
          "name": "type",
          "derivation": "fixed",
          "function": "parse"
        })

        let computeModules = [];
        
        if (requiredModules.orderVars) { // 有新戶模組
          computeModules.push({ 
            "name": "orderVars",
            "url": `${process.env.VUE_APP_PROMOTIONPLUGIN}/sysapis/promotion-plugins/order-times`, // 這邊固定問production會有問題吧
            "fetch": {
              "method": "POST",
              "auth": "iiot"
            }
          })
        }
      
        console.log(JSON.stringify(formulas));
        return {
          formulas: formulas,
          computeModules: computeModules
        }
      }

      this.isCreating = true;
      console.log("this.promotionSettings: " + JSON.stringify(this.promotionSettings));
      var isChecked = this.editableTabs.filter(function(obj) {
        return obj.isChecked == true;
      });
      if (isChecked.length < 1) {
        this.$message({
          type: "error",
          message: "「全部」、「內用」、「自取」、「外帶」至少需選取一種"
        });
        this.isCreating = false;
        return;
      }
      console.log(moment(this.promotionSettings.start).diff(moment(this.promotionSettings.end)))
      if (moment(this.promotionSettings.start).diff(moment(this.promotionSettings.end)) >= 0) {
        this.$message({
          type: "error",
          message: "優惠開始時間須早於優惠結束時間"
        });
        this.isCreating = false;
        return;
      }
      
      // this.isCreating = true;
      var promotionSettings = {
        displayName: this.promotionSettings.name || "一般折扣",
        start: this.promotionSettings.start,
        end: this.promotionSettings.end,
        settings: {},
        carryMethod: this.promotionSettings.carryMethod // 搬出來
      };

      let valid = true;;
      this.editableTabs.forEach(function(obj) {
        if (obj.editablePromotion.usageRestrctions.restrictionType === 'carts') {
          let cartPromotions = obj.editablePromotion.usageRestrctions[obj.editablePromotion.usageRestrctions.restrictionType];
          if (!cartPromotions) {
            valid = false;
          } else {
            cartPromotions.forEach(item => {
              if (!item.carts || !item.amount) {
                valid = false;
              }
            })
          }
        }
        promotionSettings.settings[obj.name] = {
          checked: obj.isChecked,
          general: {
            totalUsage:
              obj.editablePromotion.general.totalUsageType === "none"
                ? null
                : obj.editablePromotion.general.totalUsage,
            discountType: obj.editablePromotion.general.discountType, // "percentage", "discountPerItems5", "discountPerItemsAvg", "discountPerItemsLow"
            carryMethod: obj.editablePromotion.general.carryMethod, // "floor", "round", "ceil"
            amount:
              obj.editablePromotion.general[
                obj.editablePromotion.general.discountType
              ] // 10% or $10
          },
          usageRestrctions: {
            // 不限制都填null
            restrictionType:
              obj.editablePromotion.usageRestrctions.restrictionType === "none"
                ? null
                : obj.editablePromotion.usageRestrctions.restrictionType, // amount, qty, perItems
            value:
              obj.editablePromotion.usageRestrctions.restrictionType === "none"
                ? null
                : obj.editablePromotion.usageRestrctions[
                    obj.editablePromotion.usageRestrctions.restrictionType
                  ]
          },
          roleRestrictions: {
            userType:
              obj.editablePromotion.roleRestrictions.userType === "none"
                ? null
                : obj.editablePromotion.roleRestrictions.userType // "old", null
          },
          usageLimits: {
            limitPerUser:
              obj.editablePromotion.usageLimits.limitPerUser === "none"
                ? null
                : obj.editablePromotion.usageLimits.limitPerUser // 優惠一人限制次數, 不限null
          }
        };
      });
      if (!valid) {
        this.$message({
          type: "error",
          message: "加購促銷設定有誤，請確認是否指定加購，以及優惠方式是否為折價"
        });
        this.isCreating = false;
        return;
      }
      // console.log(JSON.stringify(promotionSettings));
      // For Legacy
      // promotionSettings.class = promotionSettings.class || "common";
      // promotionSettings.content = promotionSettings.content ||
      // {
      //   "type": "fixed",
      //   "target": "amount",
      //   "th": 0,
      //   "value": "0"
      // };
      // promotionSettings.enabled = (typeof promotionSettings.enabled === 'undefined' ? false : promotionSettings.enabled);
      // promotionSettings.roundingType = promotionSettings.roundingType || 0;
      // promotionSettings.displayName = "一般折扣"; // TODO: 要讓用戶輸入
      // promotionSettings.description = "折扣內容";

      let createPromotionData = {
        businessId: this.businessId,
        // promotion: promotionSettings
      };
      console.log("createPromotionData: " + JSON.stringify(createPromotionData));

      // setting to formulas     

      let formulaData = settingToFormula(promotionSettings);

      
      let finalData = {
        content: {
          type: 'fixed',
          target: '',
          th: 0,
          value: '0',
          start: promotionSettings.start,
          end: promotionSettings.end,
          formulas: formulaData.formulas,         
        },
        enabled: false,
        roundingType: 0,
        start: promotionSettings.start, 
        end: promotionSettings.end,
        class: 'common', 
        description: promotionSettings.displayName,
        displayName: promotionSettings.displayName
      }
      if (formulaData.computeModules) {
        finalData.content.computeModules = formulaData.computeModules;
      }
      createPromotionData.promotion = finalData;
      
      console.log('call create promotion ' + JSON.stringify(createPromotionData));
      createPromotion(createPromotionData, this.type)
        .then(res => {
          console.log("createPromotionRes: ", res.data);
          this.$message({
            type: "success",
            message: "新增成功"
          });
          this.isCreating = false;
          this.dialogFormVisible = false;
          this.getPromotions();
        })
        .catch(err => {
          console.log("err: ", err);
          this.$message({
            type: "error",
            message: err.message
          });
          this.isCreating = false;
        });
    },
    onAddCartPromotion(editPromotion) {
      console.log('onAddCartPromotion', editPromotion)
      editPromotion.usageRestrctions.carts.push({...this.defaultCartPromotion})
    },
    onRemoveCartPromotion(data){
      console.log('onRemoveCartPromotion');
      data.editablePromotion = data.editPromotion.usageRestrctions.carts.splice(data.removeIndex, 1)
    }
    
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
<style scoped>
.display-flex {
  display: flex !important;
}
.display-none {
  display: none !important;
}
.popDiscountAnno {
 .popBody {
  width: 500px!important;
 }
}
.trashAnno {
  color: #DF0730;
  cursor: pointer;
  font-size: 18px;
  margin-left: 10px;
  display: inline;
  width: 28px;
}
</style>
